<template >
    <div id="CommonBreadcrumb">
        <div class="mybreadcrumb">
            <slot></slot>
            <el-breadcrumb separator-class="el-icon-arrow-right" >
                <el-breadcrumb-item 
                    v-for="(item,index) in  breadcrumb" 
                    :key="index">{{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </div>
</template>

<script>
export default {
    name:'CommonBreadcrumb',
    props:{
        breadcrumb:{
            type:Array,
            default(){
                return []
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            padding: 13px 0 13px 20px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #EAEAEA;
        }
</style>


// WEBPACK FOOTER //
// src/components/CommonBreadcrumb.vue